module.exports = __webpack_public_path__ + "img/744.57c52dc9.jpg";